import React__default from "react";
function instanceOfGrid(object) {
  return "items" in object;
}
function getContainerWithProps(item) {
  const Container = item.Container ?? React__default.Fragment;
  const props = item.Container ? item.containerProps : {};
  return {
    Container,
    props
  };
}
function getColProps(item) {
  const { colStyle, background, className, flex, span, order, offset, pull, push, xxl, xl, lg, md, sm, xs } = item;
  return {
    style: colStyle,
    background,
    className,
    flex,
    span,
    order,
    offset,
    pull,
    push,
    xxl,
    xl,
    lg,
    md,
    sm,
    xs
  };
}
function getRowProps(item) {
  const { style, background, className, align, justify, gutter, wrap } = item;
  return {
    style,
    background,
    className,
    align,
    justify,
    gutter,
    wrap
  };
}
export {
  getColProps,
  getContainerWithProps,
  getRowProps,
  instanceOfGrid
};
//# sourceMappingURL=Grid.utils.js.map
